var map = {
	"./": 50322,
	"./about_us": 14368,
	"./about_us/": 14368,
	"./about_us/index": 14368,
	"./about_us/index.jsx": 14368,
	"./apply": 51216,
	"./apply/": 51216,
	"./apply/index": 51216,
	"./apply/index.jsx": 51216,
	"./apply/style.css": 14616,
	"./careers": 41333,
	"./careers/": 41333,
	"./careers/careers_detail": 42166,
	"./careers/careers_detail/": 42166,
	"./careers/careers_detail/index": 42166,
	"./careers/careers_detail/index.jsx": 42166,
	"./careers/index": 41333,
	"./careers/index.jsx": 41333,
	"./contacts": 41999,
	"./contacts/": 41999,
	"./contacts/index": 41999,
	"./contacts/index.jsx": 41999,
	"./home/Banner": 52546,
	"./home/Banner/": 52546,
	"./home/Banner/index": 52546,
	"./home/Banner/index.jsx": 52546,
	"./home/news_releases": 95274,
	"./home/news_releases/": 95274,
	"./home/news_releases/index": 95274,
	"./home/news_releases/index.jsx": 95274,
	"./home/our_partners": 94173,
	"./home/our_partners/": 94173,
	"./home/our_partners/index": 94173,
	"./home/our_partners/index.jsx": 94173,
	"./home/our_portfolio": 47360,
	"./home/our_portfolio/": 47360,
	"./home/our_portfolio/index": 47360,
	"./home/our_portfolio/index.jsx": 47360,
	"./home/our_solution": 62037,
	"./home/our_solution/": 62037,
	"./home/our_solution/index": 62037,
	"./home/our_solution/index.jsx": 62037,
	"./index": 50322,
	"./index.jsx": 50322,
	"./news": 28420,
	"./news/": 28420,
	"./news/index": 28420,
	"./news/index.jsx": 28420,
	"./news/news_detail": 91893,
	"./news/news_detail/": 91893,
	"./news/news_detail/index": 91893,
	"./news/news_detail/index.jsx": 91893,
	"./products": 18508,
	"./products/": 18508,
	"./products/crm": 32040,
	"./products/crm/": 32040,
	"./products/crm/index": 32040,
	"./products/crm/index.jsx": 32040,
	"./products/fms": 19621,
	"./products/fms/": 19621,
	"./products/fms/index": 19621,
	"./products/fms/index.jsx": 19621,
	"./products/hrm": 51944,
	"./products/hrm/": 51944,
	"./products/hrm/index": 51944,
	"./products/hrm/index.jsx": 51944,
	"./products/index": 18508,
	"./products/index.jsx": 18508,
	"./products/lms": 83776,
	"./products/lms/": 83776,
	"./products/lms/index": 83776,
	"./products/lms/index.jsx": 83776,
	"./products/sns": 73723,
	"./products/sns/": 73723,
	"./products/sns/index": 73723,
	"./products/sns/index.jsx": 73723,
	"./solutions": 80940,
	"./solutions/": 80940,
	"./solutions/bigdata": 46819,
	"./solutions/bigdata/": 46819,
	"./solutions/bigdata/index": 46819,
	"./solutions/bigdata/index.jsx": 46819,
	"./solutions/blockchain": 21459,
	"./solutions/blockchain/": 21459,
	"./solutions/blockchain/index": 21459,
	"./solutions/blockchain/index.jsx": 21459,
	"./solutions/index": 80940,
	"./solutions/index.jsx": 80940,
	"./solutions/iots": 16388,
	"./solutions/iots/": 16388,
	"./solutions/iots/index": 16388,
	"./solutions/iots/index.jsx": 16388,
	"./solutions/our_sourcing": 17419,
	"./solutions/our_sourcing/": 17419,
	"./solutions/our_sourcing/index": 17419,
	"./solutions/our_sourcing/index.jsx": 17419,
	"./solutions/twells": 3582,
	"./solutions/twells/": 3582,
	"./solutions/twells/index": 3582,
	"./solutions/twells/index.jsx": 3582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32150;